import Table from "./table";
import TableHeader from "./tableHeader";
import TableBody from "./tableBody";

export default Table;
export { TableHeader, TableBody };
